import script from "./TextWithNotesHtml.vue?vue&type=script&setup=true&lang=js"
export * from "./TextWithNotesHtml.vue?vue&type=script&setup=true&lang=js"

import "./TextWithNotesHtml.vue?vue&type=style&index=0&id=69e49c6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e49c6b"]])

export default __exports__